import React from 'react';

import AddToGooglePayDark from './no_add_to_Pay_Dark.png';

export const AddToGooglePayImage = () => (
    <img className="add-to-google-pay-button__image" src={AddToGooglePayDark} alt="Legg til i Google Pay" />
);
